export default __webpack_public_path__ + "static/media/bxl-github.7f5f78b1.svg";